"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useConfig = _interopRequireDefault(require("../../hooks/useConfig"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const UpsellBreakdownWrapper = props => {
  const currentTenant = (0, _useConfig.default)('tenant');
  const tenantsWithHiddenOrderSummary = (0, _useConfig.default)('tenantsWithHiddenOrderSummary', []);
  const isHiddenOrderSummary = tenantsWithHiddenOrderSummary.includes(currentTenant);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !isHiddenOrderSummary && props.children);
};
var _default = UpsellBreakdownWrapper;
exports.default = _default;